import React, { Component } from 'react'

export default class Label extends Component {
  render() {
    const { name, label, type, required }= this.props
    return (
      <div className="w-full text-start ">
        {type === "input" && (
            <div className="flex align-center pl-2 ">
                {required === true && (<div className="mr-1"><sup>*</sup></div>)}
                <label htmlFor={name} className="text-gray-500 leading-5 text-xs">{ label }</label>
            </div>
        )}
        {type === "select" && (
            <div className="flex align-center pl-2 mb-1">
                {required === true && (<div className="mr-1"><sup>*</sup></div>)}
                <label htmlFor={name} className="text-gray-500 leading-5 text-xs">{ label }</label>
            </div>
        )}
        {type === "checkbox" && (
            <div
                htmlFor={name} 
                className="text-start pl-2 "
                dangerouslySetInnerHTML={{__html: label}}
            />
        )}
        
      </div>
    )
  }
}

